import { createHashHistory } from 'history';

class AppRouter {
  constructor() {
    this.browserHistory = createHashHistory();
  }

  goTo(path, state) {
    this.browserHistory.push(path, state);
  }

  replace(path, state) {
    this.browserHistory.replace(path, state);
  }

  goBack() {
    this.browserHistory.goBack();
  }

  getHistory() {
    return this.browserHistory;
  }
}

export default new AppRouter();
